import React from "react";
import { BrowserRouter } from "react-router-dom";

import "./scss/index.scss";

import ConfigLoader from "./areas/ConfigLoader";

function App() {
    return (
        <BrowserRouter>
            <ConfigLoader />
        </BrowserRouter>
    );
}

export default App;
